import React from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
import StorageImage from './StorageImage';

interface RailingSystemProps {
  title: string;
  image: string;
  description: string;
}

const RailingSystem = ({ title, image, description }: RailingSystemProps) => {
  const { trackProductInteraction } = useAnalytics();

  const handleClick = () => {
    trackProductInteraction(title, 'view');
  };

  return (
    <div
      className="group relative overflow-hidden rounded-2xl shadow-lg cursor-pointer"
      onClick={handleClick}
    >
      <StorageImage
        path={image}
        alt={title}
        className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent flex flex-col justify-end p-4 sm:p-6 md:p-8 translate-y-8 group-hover:translate-y-0 transition-transform duration-300">
        <h3 className="text-white text-lg sm:text-xl md:text-2xl font-semibold mb-2 sm:mb-3">{title}</h3>
        <p className="text-gray-200 text-sm sm:text-base leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300">{description}</p>
      </div>
    </div>
  );
};

export default RailingSystem;
